import { useAppSelector } from '../slices/commonSelectors';

const POWER_OUTAGES = 'POWER_OUTAGES' as const;
const OFFLINE_ENVIRONMENT = 'OFFLINE_ENVIRONMENT' as const;
const STREAMLINE_PLATFORM = 'STREAMLINE_PLATFORM' as const;
const NOTIFICATION_JOBS = 'NOTIFICATION_JOBS' as const;
const SHOW_FAULTY_EVENT_HAZARD_CATEGORIES =
  'SHOW_FAULTY_EVENT_HAZARD_CATEGORIES' as const;
const NEO = 'NEO' as const;
const VELCO = 'VELCO' as const;
const SITREP_LANDING = 'SITREP_LANDING' as const;
const DGPT_ALERTS = 'DGPT_ALERTS' as const;
const EMW_DGPT = 'EMW_DGPT' as const;
const AI_AGENT = 'AI_AGENT' as const;
const HIGH_SECURITY = 'HIGH_SECURITY' as const;

export const ALL_FEATURE_FLAGS = [
  POWER_OUTAGES,
  OFFLINE_ENVIRONMENT,
  STREAMLINE_PLATFORM,
  NOTIFICATION_JOBS,
  SHOW_FAULTY_EVENT_HAZARD_CATEGORIES,
  NEO,
  VELCO,
  SITREP_LANDING,
  DGPT_ALERTS,
  EMW_DGPT,
  AI_AGENT,
  HIGH_SECURITY,
] as const;

export type FeatureFlag = (typeof ALL_FEATURE_FLAGS)[number];

export const useFeatureFlag = (flag: FeatureFlag) => {
  const flags = useAppSelector((s) => s.app.featureFlags);
  return flags.includes(flag);
};

export const usePowerOutagesFlag = () => {
  return useFeatureFlag(POWER_OUTAGES);
};
export const useOfflineEnvironmentFlag = () => {
  return useFeatureFlag(OFFLINE_ENVIRONMENT);
};
export const useStreamlinePlatformFlag = () => {
  return useFeatureFlag(STREAMLINE_PLATFORM);
};
export const useNotificationJobsFlag = () => {
  return useFeatureFlag(NOTIFICATION_JOBS);
};
export const useShowFaultyHazardEventCategoriesFlag = () => {
  return useFeatureFlag(SHOW_FAULTY_EVENT_HAZARD_CATEGORIES);
};
export const useNeoFlag = () => {
  return useFeatureFlag(NEO);
};
export const useVelcoFlag = () => {
  return useFeatureFlag(VELCO);
};
export const useSitrepLandingFlag = () => {
  return useFeatureFlag(SITREP_LANDING);
};
export const useDgptAlertsFlag = () => {
  return useFeatureFlag(DGPT_ALERTS);
};
export const useEmwDgptFlag = () => {
  return useFeatureFlag(EMW_DGPT);
};
export const useAiAgentFlag = () => {
  return useFeatureFlag(AI_AGENT);
};
export const useHighSecurityFlag = () => {
  return useFeatureFlag(HIGH_SECURITY);
};
